/**
 * This module has the hook, declaration types and tests for the cartRemoveProduct mutation
 * {@label CART_REMOVE_PRODUCT}
 */
import useCartRemoveProduct from './hook'

export * as mutation from './mutation'
export * as types from './types'
export default useCartRemoveProduct
